import Image from 'next/image'

import HeadingImage from '@/assets/images/storefronts/clashroyale/gems-heading.png'

import { StoreTypography } from '../../_storeBase/typography/StoreTypography'

import styles from './ProductCategory.module.scss'

interface ProductCategoryHeaderProps {
  title: string
}

export const ProductCategoryHeader = ({ title }: ProductCategoryHeaderProps) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.imageContainer}>
        <Image src={HeadingImage} alt="offers-heading-image" fill />
        <div className={styles.headerText}>
          <StoreTypography tag="h2" textSize="md" style="plain">
            {title}
          </StoreTypography>
        </div>
      </div>
    </div>
  )
}
